import React, { useEffect, useRef } from 'react'

export const Input = props => {
    const { context, defaultValue, element, modelPath, type, autocomplete } = props;      
    const inputModel = context.readModel(modelPath, defaultValue);
    let inputRef = useRef(null);

    const change = () => {
        const errors = context.validateElement(inputRef.current, element, inputRef.current.value);
        context.updateModel(modelPath, inputRef.current.value, errors);
    }

    useEffect(() => {
        context.validators.subscribe(change);
        return () => context.validators.unsubscribe(change);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context, element, modelPath, inputRef]);

    return (
        <input
            type={type}
            ref={inputRef}
            autoComplete={autocomplete ?? "off"}
            className={"form-control" + (inputModel.errors.length !== 0 ? " is-invalid" : "") + (element.className ? " " + element.className : "")}
            disabled={element.disabled || context.isReadOnly}
            max={element.max}
            maxLength={element.maxLength}
            min={element.min}
            minLength={element.minLength}
            name={element.name}
            onBlur={change}
            onChange={change}
            onFocus={change}
            pattern={element.pattern}
            step={element.step}
            required={element.required}
            value={inputModel.value}
        />            
    )
}

export default Input;